module.exports = __webpack_public_path__ + "img/sps_servicios_proteccion_salud.01f86648.png";